import datapoints from '../datapoints';
import reportMessageToSafetyLibraryService from 'owa-mail-triage-action/lib/services/reportMessageToSafetyLibraryService';
import SafetyApiAction from 'owa-service/lib/contract/SafetyApiAction';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { TableView } from 'owa-mail-list-store';

/**
 * The action which marks items as phishing.
 * @param itemIds - the itemIds to mark as phishing * @param actionSource - where this mark as phishing action is triggered
 * @param markAsPhishingStoreUpdate the callback function to update the store upon markItemsAsPhishingDatapoint as phishing
 * @returns a promise to end the markItemsAsPhishingDatapoint datapoint
 */
export default createLegacyActionWithDatapoint(
    'markItemsAsPhishing',
    datapoints.markItemsAsPhishing
)(function markItemsAsPhishingBasedOnItemIds(
    itemIds: string[],
    tableView: TableView,
    actionSource: ActionSource,
    markAsPhishingStoreUpdate: () => void
): Promise<void> {
    try {
        reportMessageToSafetyLibraryService(itemIds, SafetyApiAction.Phish);
    } catch (error) {
        // VSO 19006: Handle service error caused by block
    }

    markAsPhishingStoreUpdate();

    // Synchronously returns the promise to end the markItemsAsPhishingDatapoint datapoint
    return Promise.resolve();
});
